import { MDBBtn, MDBContainer, MDBIcon } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { DataTable } from "stm-frontend-library";
import {
  checkIsAdmin,
  enableUser,
  getUsers,
  showErrorToast,
} from "../../helpers";
import { makeColumns } from "./columns";
import CreateUserModal from "./CreateUserModal";
import DisableUserModal from "./DisableUserModal";

const Users = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const isAdmin = checkIsAdmin();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDisableModalOpen, setIsDisableModalOpen] = useState(false);
  const [disableUsername, setDisableUsername] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const { data: response } = await getUsers();
        setData(response ?? []);
      } catch (error) {
        showErrorToast();
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleEnableUser = async (username) => {
    try {
      setIsLoading(true);
      await enableUser(username);
      window.location.reload();
    } catch (error) {
      showErrorToast("Could not enable user");
    } finally {
      setIsLoading(false);
    }
  };

  const userIsAdmin = (user, username) => {
    if (user.is_admin) {
      return <MDBIcon icon="check" size="lg" color="primary" />;
    } else {
      return <></>;
    }
  };

  const userStatus = (user, username) => {
    if (user.name === username) {
      return `👤 (you)`;
    } else {
      if (user.enabled) {
        return <p className={"text-success"}>enabled</p>;
      } else {
        return <p className={"text-secondary"}>disabled</p>;
      }
    }
  };

  const userAction = (user, username) => {
    const isDisabled = user.is_admin || !isAdmin || user.name === username;

    if (user.enabled) {
      return (
        <MDBBtn
          color={"secondary"}
          disabled={isDisabled}
          onClick={() => {
            setDisableUsername(user.name);
            setIsDisableModalOpen(true);
          }}
        >
          Disable
        </MDBBtn>
      );
    } else {
      return (
        <MDBBtn
          color={isDisabled ? "secondary" : "primary"}
          disabled={isDisabled}
          onClick={() => handleEnableUser(user.name)}
        >
          Enable
        </MDBBtn>
      );
    }
  };

  const username = localStorage.getItem("username");
  const mappedData = data.map((x) => ({
    ...x,
    admin: userIsAdmin(x, username),
    status: userStatus(x, username),
    action: userAction(x, username),
  }));

  return (
    <>
      <MDBContainer className="my-5">
        {isAdmin && (
          <MDBBtn
            color="primary"
            size="md"
            onClick={() => setIsCreateModalOpen(true)}
            className={"mb-3"}
          >
            <MDBIcon icon="plus-circle" className="me-2" />
            New user
          </MDBBtn>
        )}
        <DataTable
          isLoading={isLoading}
          rows={mappedData}
          columns={makeColumns(isAdmin)}
        />
      </MDBContainer>
      <CreateUserModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
      <DisableUserModal
        isOpen={isDisableModalOpen}
        username={disableUsername}
        onClose={() => {
          setIsDisableModalOpen(false);
          setDisableUsername("");
        }}
      />
    </>
  );
};

export default Users;
